export enum Order {
  Asc = 1,
  Desc = -1,
}

export enum SortOrder {
  ASC = 'ASC',
  DESC = 'DESC',
}
